import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// routes
import { publicRoutes } from './allRoutes';
import StaticNavbar from '../Components/Common/StaticNavbar';
import { useSelector } from 'react-redux';
import { SelectFullStateOfThisAPI } from '../Store/callAPI/selectors';
import { AuthenticationAPI, AuthenticationLegacyAPI } from '../helpers/APIS/CommonApisSchema';
import { DataKey } from '../Store/callAPI/allAPIs';
import StaticFooter from '../Components/Common/StaticFooter';
import Loader from '../Components/Common/Loader';

const Index = () => {
    const AuthenticationAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, AuthenticationAPI));
    const AuthenticationLegacyAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, AuthenticationLegacyAPI));
    let authenticatedData = AuthenticationAPIData?.[DataKey]?.data || AuthenticationLegacyAPIData?.[DataKey]?.data;

    return (
        <>
            {authenticatedData && <StaticNavbar />}
            <Suspense fallback={<Loader />}>
                <Routes>
                    <Route>
                        {publicRoutes.map((route, idx) => (
                            <Route path={route.path} element={<>{route.component}</>} key={idx + route.path} exact={true} />
                        ))}
                    </Route>
                </Routes>
            </Suspense>
            {authenticatedData && <StaticFooter />}
        </>
    );
};

export default Index;
